/**
 * Affichage des dates à la française dans l’UI : JJ-MM-AAAA (tirets).
 * Les données métiers restent généralement en YYYY-MM-DD ; on formate uniquement à l’affichage.
 */

function pad2(n) {
  return String(n).padStart(2, "0");
}

/** Chaîne uniquement jour `YYYY-MM-DD` ? */
export function isIsoDateOnlyString(s) {
  return typeof s === "string" && /^\d{4}-\d{2}-\d{2}$/.test(s.trim());
}

/**
 * Formate une date « jour » (YYYY-MM-DD, ou parsable comme date civile locale).
 */
export function formatDateFr(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  if (!raw || raw === "—") return raw === "—" ? "—" : "";

  const head = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (head) {
    const y = Number(head[1]);
    const mo = Number(head[2]);
    const da = Number(head[3]);
    const chk = new Date(y, mo - 1, da);
    if (
      chk.getFullYear() === y &&
      chk.getMonth() === mo - 1 &&
      chk.getDate() === da
    ) {
      return `${pad2(da)}-${pad2(mo)}-${y}`;
    }
  }

  const ts = Date.parse(raw);
  if (Number.isNaN(ts)) return raw;
  const d = new Date(ts);
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}

/**
 * Timestamp ISO avec heure (API) → JJ-MM-AAAA HH:mm locales.
 * Si la valeur est clairement un jour uniqué (YYYY-MM-DD ou minuit UTC), retour JJ-MM-AAAA.
 */
export function formatDateTimeFr(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  if (!raw || raw === "—") return raw === "—" ? "—" : "";

  if (isIsoDateOnlyString(raw)) {
    return formatDateFr(raw);
  }

  const zuluMidnightOnly = raw.match(/^(\d{4}-\d{2}-\d{2})T00:00:00(?:\.\d+)?(?:Z|[+-]00:00)?$/);
  if (zuluMidnightOnly) {
    return formatDateFr(zuluMidnightOnly[1]);
  }

  const ts = Date.parse(raw);
  if (Number.isNaN(ts)) {
    return formatDateFr(raw);
  }
  const d = new Date(ts);
  const datePart = `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;

  const hasExplicitTime = /\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(raw);

  if (!hasExplicitTime) {
    return datePart;
  }
  return `${datePart} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
